var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.83 15.35l-3.28-3.28 1.06-1.06 2.22 2.22 4.97-4.97 1.06 1.06-6.03 6.03zM12.21.19L3.46 3.66v10.18c0 2.24 1.09 4.39 2.92 5.75l5.83 4.35 5.83-4.35c1.83-1.36 2.92-3.51 2.92-5.75V3.66L12.21.19z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.83 15.35l-3.28-3.28 1.06-1.06 2.22 2.22 4.97-4.97 1.06 1.06-6.03 6.03zM12.21.19L3.46 3.66v10.18c0 2.24 1.09 4.39 2.92 5.75l5.83 4.35 5.83-4.35c1.83-1.36 2.92-3.51 2.92-5.75V3.66L12.21.19z",
    fill: "#6e6e6e",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e90a0a",
    d: "M0 0h6.27v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26221e",
    d: "M6.27 0h1v24h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff8600",
    d: "M6.98 0h6.46v24H6.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ae0000",
    d: "M13.44 0h4.22v24h-4.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0065b1",
    d: "M17.66 0h1v24h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008520",
    d: "M18.11 0H24v24h-5.89z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.2ac97ad001dd707b5cbdd687d614ce86.svg";
export { ForwardRef as ReactComponent };